export const NATIVE_STORE_FINISHED_STATE = "finished";

export const isNativeStoreAlreadyOwnedError = (error) => {
  const code = String(error?.code || "").trim().toUpperCase();
  const message = String(error?.message || "").trim().toUpperCase();

  return (
    code === "7" ||
    code === "ITEM_ALREADY_OWNED" ||
    message.includes("ITEM_ALREADY_OWNED") ||
    message.includes("ITEM ALREADY OWNED") ||
    message.includes("ALREADY OWNS THIS ITEM")
  );
};

const transactionTouchesProductIds = (transaction, productIds) =>
  (transaction?.products || []).some((product) =>
    productIds.has(String(product?.id || "").trim())
  );

export const getPendingRestorableTransactionIds = (
  transactions = [],
  restorableProductIds = [],
  finishedState = NATIVE_STORE_FINISHED_STATE
) => {
  const productIds = new Set(
    (restorableProductIds || []).map((productId) => String(productId || "").trim())
  );
  return (transactions || [])
    .filter(
      (transaction) =>
        String(transaction?.state || "").trim() !== finishedState &&
        transaction?.isAcknowledged !== true &&
        transaction?.isConsumed !== true &&
        transactionTouchesProductIds(transaction, productIds)
    )
    .map((transaction) => String(transaction?.transactionId || "").trim())
    .filter(Boolean);
};
